<template>
	<div class="indexbg">
		<topbar></topbar>
		<header></header>
		<emallheader ref="eh"></emallheader>
		<div class="clear mt15"></div>

		<!--container 开始-->
		<div class="w1200 bc">
			<!--购物车：开始-->
			<div class="hq-shopping-cart">
				<!--购物流程：开始-->
				<div class="hq-reg-step">
					<ul class="ico">
						<li class="active">
							<p class="item">Shopping Cart</p>
							<i class="step-count"></i>
						</li>
						<li><span class="line"></span></li>
						<li>
							<p class="item">Submit Orders</p>
							<i class="step-count"></i>
						</li>
						<li><span class="line"></span></li>
						<li>
							<p class="item">Confirm Payment</p>
							<i class="step-count"></i>
						</li>
						<li><span class="line"></span></li>
						<li>
							<p class="item">Successfully Ordered</p>
							<i class="step-count"></i>
						</li>
					</ul>
				</div>
				<!--购物流程：结束-->

				<!--我的购物车：开始-->
				<div class="bd-box buycart-list mt20">
					<div class="hd">
						<dl>
							<dt class="col-1">
                        <input id="allCheck" name="" type="checkbox" value="" v-on:click="checkAll()" >
                        <label for="allCheck">Select</label>
                     </dt>
						<dt class="col-2"><span class="ml120">Product Name</span></dt>
						<dt class="col-3">Unit price</dt>
						<dt class="col-4">Quantity</dt>
						<dt class="col-5">Total Price</dt>
						<dt class="col-6">Action</dt>
						</dl>
					</div>
					<div class="bd">
						<div v-if="shopBoList.length==0" style="text-align: center;font-size: 20px;">
							The shopping cart is empty, go <router-link :to="{path:'/'}" style="color: blue;">Shopping</router-link>！
						</div>
						<div  v-for="(shop,index) in shopBoList" class="items">
						    <div class="shop-name" >
								<!--<input name="" type="checkbox" value=""> -->
								Shop：{{shop.shopNameEn}}
								<!--<a class="co-o-1 ml20" href="#">在线咨询</a>-->
							</div>
							<dl v-if="bo" v-for="(bo,boIndex) in shop.boListIn" v-bind:id="bo.goodsCode+'_cart_pro'">
								<dd class="col-1" v-if="bo.isDelete=='Y'">
									Expired
								</dd>
								<dd class="col-1" v-if="bo.isDelete!='Y'">
									<input name="goodsCheckBox"  v-bind:id="bo.goodsCode+'_chbox'" type="checkbox" v-bind:disabled="bo.goodsStatus!='listing'||bo.isExpired=='y'" 
										v-bind:goodsId="bo.id" v-bind:goodsCode="bo.goodsCode" v-bind:goodsName="bo.goodsNameEn" v-bind:specName="bo.specName" v-on:click="chooseGoods($event)" >
								</dd>
								<dd class="col-2" style="position: relative;">
									<a class="pic fl" href="#">
										<img v-bind:src="bo.imgSmall" width="118" height="100"  v-on:click="toDetail(bo.goodsCode)">
									</a>
									<p class="title">
										<!--<router-link :to="{path:'goodsDetails',query:{goodsCode:'bo.goodsCode'}}">{{ bo.goodsName }}</router-link>-->
										 <a class="co-b-2 name" v-bind:class="{'delisting-color':(bo.goodsStatus=='delisting'||bo.isExpired=='y')}" v-on:click="toDetail(bo.goodsCode)">{{ bo.goodsNameEn }}</a>
									</p>
									<div style="position: absolute;top:50px;left: 200px;;" v-if="bo.goodsStatus=='delisting'" >
										<img src="../../../static/images/xj.png" width="80" height="80">
									</div>
									<div style="position: absolute;top:50px;left: 200px;;" v-if="bo.isExpired=='y'" >
										<img src="../../../static/images/ysx.png" width="80" height="80">
									</div>
									<div style="position: absolute;top:70px;left: 142px;" >
										<span class="co1"><!--<i class="ico-sp-tk"></i>-->{{bo.specNameEn}}</span>
									</div>									
									<div style="position: absolute;top:90px;left: 142px;" v-if="bo.seven_day_return=='Y'">
										<span class="co1"><i class="ico-sp-tk"></i>Support 7 days no reason to return service</span>
									</div>
									
									
								</dd>
								<dd class="col-3 co-r-1 f14" v-bind:class="{'delisting-color':(bo.goodsStatus=='delisting'||bo.isExpired=='y')}" v-bind:id="bo.id+'_price'" v-if="bo.goodsPrice>0">{{ bo.goodsPrice}}point</dd>
								<dd class="col-3 co-r-1 f14" v-bind:class="{'delisting-color':(bo.goodsStatus=='delisting'||bo.isExpired=='y')}" v-bind:id="bo.id+'_price'" v-else>￥{{ bo.unitPrice}}</dd>
								<dd class="col-4" >
									<div class="item-amount">
										<a class="minus" v-on:click="subPayNum(bo.id,bo.goodsCode)">-</a>
										<input v-bind:id="bo.id+'_goods_number'"onkeypress="return(/[\d]/.test(String.fromCharCode(event.keyCode)))" v-on:keyup="setPayNum(bo.id,bo.goodsCode,bo.goodsStock)" v-bind:value="bo.goodsNumber" class="text-amount" min="1" v-bind:max="bo.goodsStock" type="text">
										<a class="plus" v-on:click = "addPayNum(bo.id,bo.goodsCode)">+</a>
									</div>
								</dd>
								<dd class="col-5 co-r-1 f14" v-bind:class="{'delisting-color':(bo.goodsStatus=='delisting'||bo.isExpired=='y')}" v-bind:id="bo.id+'_unitPrice'" name="unitPrice">{{ bo.ext1 }}</dd>
								<dd class="col-6 co-r-1 f12" >
									<!--<a href="#">移入收藏夹</a><br/>-->
									<a v-on:click="deleteGoods(bo.id,bo.goodsCode,index)" >Delete</a>
								</dd>
							</dl>
							
						</div>
						
						<div class="total tr co5">
							<ul>
								<li class="fr">
									selected <span class="co-o-1 f18" id = "selectedCount">0</span> Items Total (excluding handling fee):
									<span class="co-o-1 f18" id="sumPay">￥0.00</span>
									<span v-if="saveMoney>0">Saved</span><span class="co-o-1 f16" v-if="saveMoney>0">￥{{saveMoney}}</span>
									<span class="ml20"><input class="a-btn-c-2" name="" type="button" value="Go to settlement" v-on:click="doSettle()"></span>
									<span class="ml20"><input class="a-btn-c-2" name="" type="button" value="Empty shopping cart" v-on:click="deleteCart()"></span>
									<!--<a class="co-b-2 f14 fr ml20" href="#">继续购物>></a>-->
									<router-link :to="{path:'/'}" class="co-b-2 f14 fr ml20" >continue shopping>></router-link>
								</li>
								<!--<li class="fl">
									<input id="allCheck" name="" type="checkbox" value="">
									<label for="allCheck">全选</label>
									<a class="ml20" href="#">移入收藏夹</a>
									<a class="ml20" href="#">删除</a>
								</li>-->
							</ul>
						</div>
					</div>
				</div>
				<!-- 失效商品屏蔽掉
				<h4 class="hd-title clear-l">失效商品 <a class="co-b-2 f12 fr" href="#">清空失效商品</a></h4>
				<div class="bd-box buycart-list invalid mt20">
					<div class="hd lose">
						<dl>
							<dt class="col-1">
                        &nbsp;
                    </dt>
							<dt class="col-2"><span class="ml120">商品名称</span></dt>
							<dt class="col-3">价格</dt>
							<dt class="col-4">数量</dt>
							<dt class="col-5">金额</dt>
							<dt class="col-6">操作</dt>
						</dl>
					</div>
					<div class="bd">
						<div class="items">
							<dl class="last">
								<dd class="col-1">
									<span class="tag-sx mt20">失效</span>
								</dd>
								<dd class="col-2">
									<a class="pic fl" href="#">
										<img src="images/temp/sp-sm-2.jpg" width="118" height="100">
									</a>
									<p class="title">
										<a class="co-b-2 name" href="#">一种锂电池正极及其制备方法以及锂离子二次电池</a>
									</p>
									<p class="xinghao">规格型号：210mm*100mm</p>
								</dd>
								<dd class="col-3 f14">￥18000</dd>
								<dd class="col-4">
									<div class="item-amount">
										<a href="#" class="minus">-</a>
										<input value="7" class="text-amount" type="text">
										<a href="#" class="plus">+</a>
									</div>
								</dd>
								<dd class="col-5 f14">￥18000</dd>
								<dd class="col-6 co-r-1 f12">
									<a href="#">移入收藏夹</a><br/>
									<a href="#">删除</a>
								</dd>
							</dl>
						</div>
					</div>
				</div>-->
				<!--我的购物车：结束-->
			</div>
			<!--购物车：结束-->

			<div class="clear"></div>
			<div class="mb20 ad-4 mt20"><img src="../../../static/images/footer-ad-1.png" width="1200" height="60"></div>
		</div>
		<!--container 结束-->
		<div class="clear"></div>
		<footermenu></footermenu>
		<footercopyright></footercopyright>
	</div>
	<!--底部 结束-->

	</div>
</template>

<script>
	
	import TopBar from '@/components/TopBar'
	import EmallHeader from '@/components/Header'
	import FooterMenu from '@/components/FooterMenu'
	import ShopNav from '@/components/ShopNav'
	import FooterCopyright from '@/components/FooterCopyright'
	import API from "../../../static/api/api.js"
	import alertConfirm from "../../../static/js/alertConfirm.js"
	import jQuery from 'jquery';
	import {getUcUrl,getImgUrl,dateFormat,getValueFromMap,showMoney,parseResult,ak} from "../../../static/js/emallUtils.js"
	import MintUI from 'mint-ui'
	import 'mint-ui/lib/style.css'
	import {MP} from '../../../static/js/map.js'
	//没用
//	import MessageBox from 'mint-ui'
	import Vue from 'vue'
	import VueRouter from 'vue-router'
	Vue.use(VueRouter)
	Vue.use(MintUI)
	//没用
//	Vue.use(MessageBox)
//	Vue.component(MessageBox.name,MessageBox);
	
	export default {
		name: 'shopcart',
		data() {
			return{
				boList:[],
				shopBoList:[],
				count:0,
				shoppingCartNum:0,
				firstIn: true,
				goodsNum:0,
				saveMoney:''
				}
		},
		components: {
			'topbar': TopBar,
			'shopnav': ShopNav,
			'emallheader': EmallHeader,
			'footermenu': FooterMenu,
			'footercopyright': FooterCopyright
		},
		methods:{
			checkAll: function() {
				if(jQuery("#allCheck").prop("checked") == true) {
					jQuery("input[name='goodsCheckBox']").each(function() {
						if(this.disabled == false)
							this.checked = true;
					})
				} else {
					jQuery("input[name='goodsCheckBox']").each(function() {
						if(this.disabled == false)
							this.checked = false;
					})
				}
				this.goodsNum = jQuery("input[name='goodsCheckBox']").length;
				this.sumPrice();
			},
			toDetail:function(goodsCode){
				//this.$router.push({ path: '/goodsDetails', query:{goodsCode:goodsCode}});
				let routeData = this.$router.resolve({ path: '/goodsDetails', query: {goodsCode: goodsCode } });
				window.open(routeData.href, '_blank');
			},
			addPayNum:function(id,goodsCode){
				var that = this;
				var num = jQuery("#"+id+"_goods_number").val() ;
				num = parseInt(num)+1 ;
				var price = parseFloat(jQuery("#"+id+"_price").text().replace("￥","")); 
				API.updateGoodsCount(goodsCode,num,id,function(ret){
					if(parseResult(ret, null, false)) {
						jQuery("#"+id+"_goods_number").val(num);
						if(jQuery("#"+id+"_price").text().indexOf("积分")!=-1){
							var unitPrice = num * price;
							jQuery("#"+id+"_unitPrice").text(unitPrice+"积分" ) ;
						}else{
							var unitPrice = (num * price).toFixed(2);
							jQuery("#"+id+"_unitPrice").text("￥"+unitPrice ) ;
						}
						
						that.$refs.eh.getShoppingCartList();
						that.$refs.eh.getShoppingCartNum();
						that.getShoppingCartNum();
						that.sumPrice();
						for(var i = 0;i<that.boList.length;i++){
							if(id ==that.boList[i].id){
								that.boList[i].goodsNumber = num;
							}
						}
					}
				})
        	},
        	subPayNum:function(id,goodsCode){
        		var that = this;
        		var num =jQuery("#"+id+"_goods_number").val();
        		if(num > 1){
        			num = parseInt(num)- 1;
        		}
        		var price = parseFloat(jQuery("#"+id+"_price").text().replace("￥","")); 
        		API.updateGoodsCount(goodsCode,num,id,function(ret){
					if(parseResult(ret, null, false)) {
						jQuery("#"+id+"_goods_number").val(num);
						if(jQuery("#"+id+"_price").text().indexOf("积分")!=-1){
							var unitPrice = num * price;
							jQuery("#"+id+"_unitPrice").text(unitPrice+"积分" ) ;
						}else{
							var unitPrice = (num * price).toFixed(2);
							jQuery("#"+id+"_unitPrice").text("￥"+unitPrice ) ;
						}
						that.$refs.eh.getShoppingCartList();
						that.$refs.eh.getShoppingCartNum();
						that.getShoppingCartNum();
						that.sumPrice();
						for(var i = 0;i<that.boList.length;i++){
							if(id ==that.boList[i].id){
								that.boList[i].goodsNumber = num;
							}
						}
					}
				})
        	},
        	chooseGoods: function(e){
        		if(e.target.checked){
        			this.goodsNum++;
        		}else{
        			jQuery("#allCheck").prop("checked",false);
        			this.goodsNum--;
        		}
        		if(this.goodsNum == 0){
        			jQuery("#allCheck").prop("checked",false);
        		}
        		if(this.goodsNum == jQuery("input[name='goodsCheckBox']").length){
        			jQuery("#allCheck").prop("checked",true);
        		}
        		this.sumPrice();
        	},
			sumPrice: function() {
				var that = this;
				var checkedGoods = "";
				var sumNum = 0;
				var specName = '';
				var goodsNumber = "";
				jQuery("input[name='goodsCheckBox']:checked").each(function() {
					checkedGoods += jQuery(this).attr("goodsCode") + ",";
					specName += jQuery(this).attr("specname") + ",";
					var num =jQuery("#"+jQuery(this).attr("goodsId")+"_goods_number").val();
					sumNum =sumNum +  parseInt(num);
					goodsNumber += jQuery("#" + jQuery(this).attr("goodsId") + "_goods_number").val() + ",";
				})
				if(checkedGoods != "") {
					var priceText="";
					API.sumGoodsPrice(checkedGoods, null, encodeURI(specName), goodsNumber,"", function(ret) {
						if(ret.data != null) {
							var goodsTotalPrice = ret.data;
							var saveMoney = goodsTotalPrice.saveMoney;
							if(saveMoney != undefined){
								saveMoney = (saveMoney/100).toFixed(2);
							}
							if(goodsTotalPrice.totalMoney>0){
								priceText+="￥"+(goodsTotalPrice.totalMoney / 100).toFixed(2);
							}else{
								priceText="￥0";
								saveMoney='0';
							}
							that.saveMoney = saveMoney;
							var num = 0;
							var goodsCodeList = new Array();
							goodsCodeList = checkedGoods.split(",");
							for(var i=0;i<goodsCodeList.length;i++){
								that.shopBoList.forEach(function(shopBoList){
									shopBoList.boListIn.forEach(function(bo){
										if(bo.goodsCode == goodsCodeList[i]){
											 num += bo.goodsNumber;
										}
									});
								});
							}
							jQuery("#sumPay").html(priceText);
							jQuery("#selectedCount").html(sumNum);
						}
					});
				}else{
					jQuery("#sumPay").html("￥ 0.00");
					jQuery("#selectedCount").html("0");
					that.saveMoney = '0.00';
				}
			},
			setNumVue: function(){
				var goodNum = 0;
				this.shopBoList.forEach(function(e){
					e.boListIn.forEach(function(good){
						goodNum += good.goodsNumber;
					});
				});
				jQuery("#selectedCount").html(goodNum);
			},
        	getShoppingCartNum:function(){
        		var that=this;
        		API.getShoppingCartNum(function(ret){
        			if(ret.code != null && ret.code == "9999") {
//						alertConfirm.singleConfirm("请先登陆！");
						window.location.href = getUcUrl() + '/login.htm';
						return false;
					}
        			that.shoppingCartNum = ret.data.shoppingCartNum;
        		})
        	},
        	getCartList:function(){
        			var that=this;
        		   	API.getShoppingCartList(function(ret){
					 if(ret.code == "success"){
					 	that.boList = ret.data.boList;
					 	//根据店铺进行分类，店铺名称=店铺
					 	var shopBoMap = {};
					 	var totalCount = 0;
					 	var goodList = new Array();
					 	goodList = ret.data.boList;
					 	var money = 0;
					 	if (goodList != null && goodList.length > 0){
						 	for(var i =0; i<goodList.length;i++){
								var goodsPrice = goodList[i].goodsPrice;
								var unitPrice = goodList[i].unitPrice;
								var attrValue = JSON.parse(goodList[i].attrValue);					 		
						 		var unitPriceAry = attrValue.unitPriceAry;
								var goodsSkuStrAry = attrValue.goodsSkuStrAry;
								var imgLargeAry = attrValue.imgLargeAry;
								var specName = goodList[i].specName;
								if (unitPriceAry != 'undefined' && unitPriceAry != null && unitPriceAry.length > 0 && specName != null &&
									specName != '' && goodsSkuStrAry != 'undefined' && goodsSkuStrAry != null && goodsSkuStrAry.length > 0 &&
									goodsSkuStrAry.indexOf(",") > -1) {
									var unitPriceArr = eval("(" + unitPriceAry + ")");
									var goodsSkuStrArr = eval("(" + goodsSkuStrAry + ")");
									var imgLargeArr = eval("(" + imgLargeAry + ")");
									for (var o = 0; o < goodsSkuStrArr.length; o++) {
										if (goodsSkuStrArr[o] == specName) {
											unitPrice = unitPriceArr[o];
											if(imgLargeArr[o]!=null&&imgLargeArr[o]!=''){
												goodList[i].imgSmall = imgLargeArr[o];
											}
											
										}
									}
								}
									
//						 		goodList[i].unitPrice = (unitPrice/ 100).toFixed(2);
						 		if(goodList[i].seckillPrice>0){
	                    			goodList[i].unitPrice = (goodList[i].seckillPrice /100).toFixed(2);
	                    		}else{
	                    			goodList[i].unitPrice = (goodList[i].unitPrice /100).toFixed(2);
	                    		}
						 		var imgSmall = goodList[i].imgSmall;
				                    if(imgSmall.indexOf(";")!=-1){
				                    	imgSmall=imgSmall.split(";")[0];
				                    }
						 		goodList[i].imgSmall = getImgUrl()+"/upload/show.htm?filePath="+imgSmall;
						 		if(goodList[i].goodsPrice>0){
						 			goodList[i].ext1 = goodList[i].goodsPrice * goodList[i].goodsNumber+"积分";
						 		}else{
						 			goodList[i].ext1 = "￥"+ (goodList[i].unitPrice * goodList[i].goodsNumber).toFixed(2) ;
						 		}
						 		//按照店铺分类
						 		var shopBo = shopBoMap[goodList[i].shopNameEn];
						 		if(shopBo==undefined){
						 			var arrayTemp = new Array();
						 			arrayTemp.push(goodList[i]);
						 			shopBo={
						 				shopNameEn:goodList[i].shopNameEn,
						 				boListIn:arrayTemp
						 			}
						 			shopBoMap[goodList[i].shopNameEn]= shopBo;
						 		}else{
						 			shopBo.boListIn.push(goodList[i]);
						 		}
						 	}
					 	}
					 	for(var j in shopBoMap){
					 		that.shopBoList.push(shopBoMap[j]);
					 	}
					 }
        		})
        		   	
        		   	console.log(this.shopBoList)
        	},
        	deleteGoods:function(id,goodsCode,index){
        		var that = this;
        		alertConfirm.alertConfirm("Are you sure to delete?？",function(){
	        			API.deleteGoods(id,goodsCode, function(ret){
	        			if(parseResult(ret, null, false)) {
	//      				that.boList.splice(index,1)
							that.$refs.eh.getShoppingCartNum();
	        				that.$refs.eh.getShoppingCartList();
	        				var shopBo = that.shopBoList[index];
	        				var boListIn = shopBo.boListIn;
        					for( var i =0; i<boListIn.length;i++ ){
        						if(boListIn[i].id==id){
        							boListIn.splice(i,1);
        						}
        					}   
	        				if(boListIn.length==0){
	        					//如果为1删除该店铺分类
	        					that.shopBoList.splice(index,1);
	        				}
	        				
	        				setTimeout(function() {
								that.sumPrice();
							}, 50)
	        				if(that.shopBoList.length <= 0){
	        					jQuery("#selectedCount").html("0");
	        					jQuery("#allCheck").prop("checked",false);
	        				}
						}else{
							alertConfirm.singleConfirm("Failed to delete item")
						}
	        		})
	        		});
        	},
        	deleteCart: function(){
        		var that = this;
        		alertConfirm.alertConfirm('Are you sure to delete?',function(){
        			that.shopBoList.forEach(function(shop){
        				shop.boListIn.forEach(function(good,index){
        					API.deleteGoods(good.id,good.goodsCode, function(ret){
	        					if(parseResult(ret, null, false)) {
	        						that.$refs.eh.getShoppingCartNum();
	        						that.$refs.eh.getShoppingCartList();
								}else{
									alertConfirm.singleConfirm("Empty shopping cart failed")
								}						
	        				})
        				});
        			});
        			jQuery("#sumPay").html("￥ 0.00");
					jQuery("#selectedCount").html("0");
        			that.shopBoList = [];
        		});
        	},
        	doSettle: function() {
				var that = this;
				//var checkedGoods = "";
				var checkedGoods =new Array();
				var goodsCodes = "";
				var specNames = "";
				var checkedName =new Array();
				var idArray = new Array();
				var selectedBos = new Array();
				var boList = new Array()
				var bos = that.boList;
	        	jQuery("input[name='goodsCheckBox']:checked").each(function(){
	        		 goodsCodes += jQuery(this).attr("goodsCode") + ",";
					specNames += jQuery(this).attr("specName") + ",";
	        	   checkedGoods.push(jQuery(this).attr("goodsCode"));
	        	   checkedName.push(jQuery(this).attr("goodsName"));
	        	   idArray.push(jQuery(this).attr("goodsId"));
	            })
	        	if(checkedGoods!=""&&checkedGoods!=undefined){
	        		for(var i=0;i<bos.length;i++){
	        			for(var k = 0;k<checkedGoods.length;k++){
	        				if(checkedGoods[k] == bos[i].goodsCode&&idArray[k]==bos[i].id){
	        					selectedBos.push(bos[i]);
	        				}
	        			}
	        		}
	        		var tmpBos = JSON.parse(localStorage.getItem('bos'));
	        		if(tmpBos != undefined && tmpBos.length>0){
	        			localStorage.removeItem('bos');
	        		}
	        		localStorage.setItem('bos',JSON.stringify(selectedBos));
	        		this.$router.push({ name: 'ordercommit', query:{goodsCodes: goodsCodes,
						specNames: specNames,bos:selectedBos,orderSource:'cart'}});
	        	}else{
	        		alertConfirm.singleConfirm("Please tick the item settlement");
	        	}
			},
			setCheckAll: function(){
				if(this.firstIn){
				jQuery("#allCheck").prop("checked",true);
				this.checkAll();
				this.firstIn = false;
				}
			},
			editPayNum: function(id,goodsCode,num){
				var that = this;
				num = parseInt(num);
				var price = parseFloat(jQuery("#"+id+"_price").text().replace("￥","")); 
				API.updateGoodsCount(goodsCode,num,id,function(ret){
					if(parseResult(ret, null, false)) {
						jQuery("#"+id+"_goods_number").val(num);
						if(jQuery("#"+id+"_price").text().indexOf("point")!=-1){
							var unitPrice = num * price;
							jQuery("#"+id+"_unitPrice").text(unitPrice+"point" ) ;
						}else{
							var unitPrice = (num * price).toFixed(2);
							jQuery("#"+id+"_unitPrice").text("￥"+unitPrice ) ;
						}
						that.$refs.eh.getShoppingCartList();
						that.$refs.eh.getShoppingCartNum();
						that.getShoppingCartNum();
						that.sumPrice();
						for(var i = 0;i<that.boList.length;i++){
							if(id ==that.boList[i].id){
								that.boList[i].goodsNumber = num;
							}
						}
					}
				})	
			},
			setPayNum: function(id,goodsCode,goodsStock){
				var num = jQuery("#"+id+"_goods_number").val(),
					maxNum = goodsStock;
/*				if(num > maxNum){
					alertConfirm.singleConfirm("订单数量大于商品库存！")
					this.editPayNum(id,goodsCode,maxNum);
				}else*/
				if(num <= 0 || num === '' || num == undefined || num == null){
					this.editPayNum(id,goodsCode,1);
				}
				else{
					this.editPayNum(id,goodsCode,num);
				}	
			},
			initMap:function(){
        		var that = this;
        		var script = document.getElementById("mapScriptId");
        		if(script == null){
	        		that.$nextTick(function(){  
			            MP(ak).then(BMap => {});
					})
        		}
        	}
//      	orderCommit:function(){
//      		var that = this;
//      		this.$router.push({ name: 'ordercommit', params:{bos:that.boList}});
//      	},
		},
		beforeMount:function(){
			this.getShoppingCartNum();
			this.getCartList();
			this.initMap();
			
		},
		mounted(){			
			window.scrollTo(0, 0);
//			alertConfirm.init();
//			this.getShoppingCartNum();
//			this.getCartList();
		},updated(){
			this.setCheckAll();
		}
	}
</script>

<style>
.mint-msgbox{
	width:50%
}
.delisting-color{
	color:#999;
}
</style>


// WEBPACK FOOTER //
// src/page/shop/shopCart.vue